<template>
    <div>
    <component :is="currentRole" ref="caution" />
    <li class="flexbox button" v-if="request_status_list['DRAFT'] == request_status">
        <a  class="btn btn-default ml-auto mr-2" v-if="my_request" :href="request_edit_link">編集する</a>
        <a  class="btn btn-danger" v-if="my_request" href="#" @click="showPopup(request_id, 'delete')">削除する</a>

        <div class="wrap-modal close-request-modal" :class="{ active: isPopupDeleteActive }" :id="'close-request-modal-' + request_id">
            <div class="content">
                <p class="txt lg-txt mb-3">要望データを削除しますか？</p>
                <div class="wrap-btn-modal mt-5">
                    <a :href="deleteUrl(request_id)" type="submit" class="btn btn-danger mb-3">削除する</a>
                </div>
                <a href="#" class="btn btn-default cancel" data-close-popup="false" @click="isPopupDeleteActive = false">戻る</a>
                <a href="#" class="close-popup" data-close-popup="false" @click="isPopupDeleteActive = false">&times;</a>
            </div>
        </div>
    </li>
    <li class="flexbox button" v-else-if="request_status_list['STOPPED'] == request_status">
        <a class="btn btn-default ml-auto mr-2 copy-request" @click="copyRequest()">コピーして新規作成</a>
        <a class="btn btn-danger" data-popup="close-request-modal" @click="showPopup(request_id)">募集を再開</a>
        <div class="wrap-modal close-request-modal" :class="{ active: isPopupActive }" :id="'close-request-modal-' + request_id">
            <div v-if="isSuccess == false" class="content">
                <p class="txt lg-txt mb-3">この要望の募集を再開しますか？</p>
                <div class="wrap-btn-modal mt-5">
                    <a href="#" data-popup="success-modal" class="btn btn-danger mb-3 confirm" @click="editRequest(request_status_list['OPENING'])">はい</a>
                    <a href="#" class="btn btn-default cancel" @click="isPopupActive = false" data-close-popup="false">戻る</a>
                </div>
                <a href="#" class="close-popup" @click="isPopupActive = false">&times;</a>
            </div>
            <div v-else class="content" id="success-content">
                <p class="icon mb-3">
                    <img src="/images/icon-success.svg">
                </p>
                <p class="txt lg-txt mb-3">要望の募集を再開しました</p>
                <p class="txt sm-txt">3 秒後に画面に戻ります</p>
            </div>
        </div>

    </li>
    <li class="flexbox button" v-else-if="request_status_list['PENDING'] == request_status || request_status_list['FINISHED'] == request_status">
        <a  class="btn btn-default ml-auto mr-2 copy-request" @click="copyRequest()">コピーして新規作成</a>
    </li>
    <li class="flexbox button" v-else>
        <a class="btn btn-default ml-auto mr-2 copy-request" @click="copyRequest()">コピーして新規作成</a>
        <a class="btn btn-danger" @click="showPopup(request_id)">募集を中止</a>
        <div class="wrap-modal close-request-modal" :class="{ active: isPopupActive }" :id="'close-request-modal-' + request_id">
            <div class="content" v-if="isSuccess == false">
                <p class="txt lg-txt mb-3">この要望の募集を中止しますか？</p>
                <div class="wrap-btn-modal mt-5">
                    <a href="#" data-popup="success-modal" class="btn btn-danger mb-3 confirm" @click="editRequest(request_status_list['STOPPED'])">はい</a>
                    <a href="#" class="btn btn-default cancel" @click="isPopupActive = false" data-close-popup="false">戻る</a>
                </div>
                <a href="#" class="close-popup" @click="isPopupActive = false" data-close-popup="false">&times;</a>
            </div>
            <div class="content" v-else id="success-content">
                <p class="icon mb-3">
                    <img src="/images/icon-success.svg">
                </p>
                <p class="txt lg-txt mb-3">要望の募集を中止しました</p>
                <p class="txt sm-txt">3 秒後に画面に戻ります</p>
            </div>
        </div>
    </li>
    </div>
</template>

<script>
import axios from 'axios';
import CautionModal from './CautionModal.vue';
    export default {
        components: { CautionModal },
        data() {
          return {
            currentRole: 'CautionModal',
            mute: false,
            request_id: 0,
            isPopupActive: false,
            isSuccess: false,
            isPopupDeleteActive: false,
            isDelete: false,
          }
        },
        methods: {
            init: function () {
                this.request_id = this.requestId ? this.requestId : 0;
            },
            showPopup(request_id, type='action'){
                if (type != 'delete') {
                    this.isPopupActive = true;
                } else {
                    this.isPopupDeleteActive = true;
                }

                const targetElement = document.getElementById('close-request-modal-' + request_id);
                const tmp = targetElement;
                targetElement.remove();
                document.body.append(tmp);
            },
            copyRequest: function() {
                const form = document.getElementById('copy_request_'+this.requestId);
                form.submit();
            },
            deleteUrl: function(id) {
                return this.request_delete_link.replace('/0/', '/'+id+'/');
            },
            editRequest: function(change_to_status) {
                this.$refs.caution.loading(true);
                this.isPopupActive = true;
                    axios({
                            headers: { 'X-Requested-With': 'XMLHttpRequest' },
                            method: 'PUT',
                            url: '/api/close-request/'+this.request_id,
                            params: { 'change_to_status': change_to_status },
                    })
                    .then(res => {
                        if (res.data.success == true)
                        {
                            this.popupMsg = res.data.msg;
                            this.isSuccess = true;
                            setTimeout(function() {
                                window.location.reload();
                            }, 3000);

                        }
                        this.$refs.caution.loading(false);
                    }).catch(err => {
                        console.error(err);
                        this.isPopupActive = false;
                        this.$refs.caution.setMessage(err.response.data.error,err.response.data.outputMessage);
                        this.$refs.caution.loading(false);
                })
            },
        },
        created() {
          this.init();
        },
        props: ['requestId', 'request_status_list', 'request_status', 'account_id', 'my_request', 'request_edit_link', 'request_delete_link'],
    }
</script>